import * as React from "react";
import ReactDOM from "react-dom";
import { cn } from "../../../helpers";
import styles from "./Loader.module.scss";

interface LoaderProps {
    show?: boolean;
    loadingText?: string;
    size?: "small" | "medium" | "large";
    className?: string;
    type?: "page" | "overlay";
}

export const Loader: React.FC<LoaderProps> = ({
    show = false,
    loadingText,
    size = "large",
    className,
    type = "overlay",
}) => {
    if (!show) return null;

    const sizeClasses = {
        small: styles.small,
        medium: styles.medium,
        large: styles.large,
    };

    const loaderClass = cn(styles.loader, sizeClasses[size], className);

    if (type === "page") {
        return ReactDOM.createPortal(
            <div
                className={styles.page}
                role="status"
                aria-live="polite"
                aria-label={loadingText || "Loading Intake System"}
            >
                <div className={styles.pageContent}>
                    <div className={styles.brandAnimation} aria-hidden="true">
                        <div className={styles.orbit}>
                            <span />
                            <span />
                            <span />
                        </div>
                        <div className={styles.monogram}>IS</div>
                    </div>
                    <div className={styles.systemLabel}>Intake System</div>
                    <div className={styles.pageLoadingText}>
                        {loadingText || "Getting things ready"}
                        <span className={styles.dots} aria-hidden="true">
                            <span>.</span>
                            <span>.</span>
                            <span>.</span>
                        </span>
                    </div>
                </div>
            </div>,
            document.body
        );
    }

    return ReactDOM.createPortal(
        <div className={styles.overlay}>
            <div className={styles.content}>
                <span className={loaderClass} />
                {loadingText && (
                    <div className={styles.loadingText}>{loadingText}</div>
                )}
            </div>
        </div>,
        document.body
    );
};

export default Loader;
